import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { StatesProvincesEntity } from './states-provinces.entity';
import { SupportedPaymentMethodTypeEntity } from './supported-payment-method-type.entity';

@Index('IDX_fk_state_province__id', ['fkStateProvinceId'], {})
@Index(
	'IDX_fk_supported_payment_method_type__id',
	['fkSupportedPaymentMethodTypeId'],
	{},
)
@Index(
	'UK_supportedPaymentMethodType_state',
	['fkSupportedPaymentMethodTypeId', 'fkStateProvinceId'],
	{ unique: true },
)
@Entity('supported_payment_method_type_state')
export class SupportedPaymentMethodTypeStateEntity extends BaseEntity {
	@Column('int', {
		name: 'fk_state_province__id',
		nullable: true,
		unsigned: true,
	})
	public fkStateProvinceId!: number | null;

	@Column('int', {
		name: 'fk_supported_payment_method_type__id',
		unsigned: true,
	})
	public fkSupportedPaymentMethodTypeId!: number;

	@ManyToOne(
		() => SupportedPaymentMethodTypeEntity,
		(supportedPaymentMethodType) =>
			supportedPaymentMethodType.supportedPaymentMethodTypeStates,
		{ onDelete: 'CASCADE', onUpdate: 'NO ACTION' },
	)
	@JoinColumn([
		{
			name: 'fk_supported_payment_method_type__id',
			referencedColumnName: 'id',
		},
	])
	public fkSupportedPaymentMethodType!: SupportedPaymentMethodTypeEntity;

	@ManyToOne(
		() => StatesProvincesEntity,
		(statesProvinces) => statesProvinces.supportedPaymentMethodTypeStates,
		{ onDelete: 'NO ACTION', onUpdate: 'NO ACTION' },
	)
	@JoinColumn([{ name: 'fk_state_province__id', referencedColumnName: 'id' }])
	public fkStateProvince!: StatesProvincesEntity;
}
